module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-richtext-fill-4880c186.svg";